<template>
    <div>
        <transition>
            <router-view></router-view>
        </transition>
    </div>
</template>
<script>
    export default {
        name: 'contentSite',
        data () {
            return {

            }
        },
        methods:{

        },
        created(){

        },
        mounted(){

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ContentSite.vue